export default __webpack_public_path__ + "static/media/icon-lines.6190d713.svg";